/** ~200 words/min; returns at least 1 for empty content. */
export function estimateReadMinutes(...parts) {
  const combined = parts.filter(Boolean).join(" ");
  const words = combined.trim().split(/\s+/).filter(Boolean).length;
  if (words === 0) return 1;
  return Math.max(1, Math.round(words / 200));
}

export const BLOG_AUTHOR_LABEL = "Scaffoindia Team";
